import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=67a26218&"
import script from "./Admission.vue?vue&type=script&lang=ts&"
export * from "./Admission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a26218')) {
      api.createRecord('67a26218', component.options)
    } else {
      api.reload('67a26218', component.options)
    }
    module.hot.accept("./Admission.vue?vue&type=template&id=67a26218&", function () {
      api.rerender('67a26218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/Admission.vue"
export default component.exports